import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1847db58"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container px-0 py-9",
  id: "wrapper-div"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Validering af Emissionsfaktorer fra excelfil", -1))
const _hoisted_3 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-error",
  role: "alert"
}
const _hoisted_4 = { class: "alert-body" }
const _hoisted_5 = { class: "alert-heading" }
const _hoisted_6 = { class: "alert-text" }
const _hoisted_7 = ["data-cy"]
const _hoisted_8 = {
  class: "col-md-3",
  style: {"padding-top":"20px","padding-bottom":"20px"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  style: {"display":"block","width":"300px","height":"30px"},
  onclick: "document.getElementById('upload-file2').click()"
}, "Vælg en excelfil for validering", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "sheetName"
}, "Excel fanenavn:", -1))
const _hoisted_11 = ["data-error", "pattern"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "d-flex justify-content-center mt-4" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "show-warnings",
  class: "ml-2"
}, "Vis advarsler", -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  class: "table--responsive-scroll",
  style: {"height":"550px","overflow":"auto"}
}
const _hoisted_20 = { class: "table w-percent-100" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, null, -1))
const _hoisted_22 = {
  key: 0,
  id: "excel-file-name",
  colspan: "5",
  style: {"text-align":"center"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"15%"},
      id: "validate_error_type"
    }, "Type"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"30%"},
      id: "validate_error_description"
    }, "Beskrivelse"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"55%"},
      id: "validate_error_value"
    }, "Værdi")
  ])
], -1))
const _hoisted_24 = { style: {"width":"15%"} }
const _hoisted_25 = { style: {"width":"30%"} }
const _hoisted_26 = {
  style: {"width":"55%"},
  class: "align-text-left-max-size"
}
const _hoisted_27 = { key: 2 }
const _hoisted_28 = {
  key: 1,
  class: "container px-0 py-9"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!

  return (_ctx.pageAccess)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.formValidation.formErrors.size)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, [
                  _createVNode(_component_SimpleText, { "text-key": "sharedContent.formErrorTitle" })
                ]),
                _createElementVNode("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formValidation.formErrors, ([key, value]) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: key,
                      "data-cy": 'error_' + key
                    }, _toDisplayString(value), 9, _hoisted_7))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("input", {
            type: "file",
            id: "upload-file2",
            style: {"display":"none"},
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addFile && _ctx.addFile(...args)))
          }, null, 32)
        ]),
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "form-input-4",
          class: "form-input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sheetName) = $event)),
          maxlength: "50",
          name: "sheetName",
          "data-error": this.sheetNameError,
          pattern: _ctx.findRegexPattern('regex.validation.calculation-name'),
          required: ""
        }, null, 8, _hoisted_11), [
          [_vModelText, _ctx.sheetName]
        ]),
        _hoisted_12,
        _createTextVNode(_toDisplayString(this.excelFileName.fileName), 1),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "button button-secondary adjust-button-size",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validateFile && _ctx.validateFile(...args)))
          }, "Valider")
        ]),
        (_ctx.validationErrors.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "show-warnings",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showWarnings) = $event)),
                class: "form-checkbox checkbox-medium"
              }, null, 512), [
                [_vModelCheckbox, _ctx.showWarnings]
              ]),
              _hoisted_16,
              (this.excelFileName.fileName)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_17, "Valideringslog. Fejl: " + _toDisplayString(_ctx.validationErrors.filter((e) => e.name !== 'Advarsel').length) + ", advarsler: " + _toDisplayString(_ctx.validationErrors.filter((e) => e.name === 'Advarsel').length), 1))
                : (_openBlock(), _createElementBlock("h2", _hoisted_18, "Valideringslog")),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("table", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (this.excelFileName.fileName)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_22, _toDisplayString(this.excelFileName.fileName), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_23,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
                      return (_openBlock(), _createElementBlock("tr", { key: item }, [
                        _createElementVNode("td", _hoisted_24, _toDisplayString(item.name), 1),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(item.value), 1),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(item.description), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(this.status), 1)),
        _createTextVNode(" " + _toDisplayString(this.deleteError), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_28, "Din brugerprofil har ikke adgang til dette skærmbillede"))
}